import * as z from "zod/v4";
import { ProductNameFilterQuery } from "../../product-name-filter";
import { AnalyticsFilterType } from "./analytics-filter-type";
import { makeReportFilterSchema } from "./base-report-filter";

export const ProductNameFilterSchema = makeReportFilterSchema(
  AnalyticsFilterType.PRODUCT_NAME,
  ProductNameFilterQuery,
  z.array(z.string()),
);

export type ProductNameFilter = z.infer<typeof ProductNameFilterSchema>;
